import React, { Fragment } from "react";
import { Container, Row, Col } from "react-bootstrap";
import StudentController from "../api/StudentController";
import PrivacySettingsView from "../components/PrivacySettingsView";
import { withData } from "../common/WithData";
import ErrorBoundary from "./ErrorBoundry";

class PrivacySettings extends React.Component
{
    studentController: StudentController;

    constructor(props: any)
    {
        super(props);
        this.studentController = new StudentController();
    }

    render(): React.ReactNode 
    {
        const PrivacySettingsData = withData(
            PrivacySettingsView,
            "Privacy Settings",
            async () => await this.studentController.getPrivacySettings()
        );

        return <Fragment>
            <ErrorBoundary>
                <h2>Privacy Settings</h2>
                <span>Please select the sections you wish to hide:</span>
                <PrivacySettingsData />
            </ErrorBoundary>
        </Fragment>;
    }
}

export default PrivacySettings;